import { request } from '@umijs/max';

// 获取商品列表
export async function getGoodPage({
  pageSize,
  current,
  filter,
  sorter,
  with: withParam,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
  with?: string[];
}) {
  return request('/api/admin/good/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: withParam,
    },
  });
}

// 获取商品详情
export async function getGoodInfo(values: API.FormValues) {
  return request('/api/admin/good/info', {
    method: 'POST',
    data: values,
  });
}

// 删除商品
export async function removeGood(values: API.FormValues) {
  return request('/api/admin/good/remove', {
    method: 'POST',
    data: values,
  });
}

// 批量导入商品
export async function importGood(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request('/api/admin/good/import', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 导出商品
export async function exportGood(params: {
  filter?: API.FormValues;
  sorter?: any[];
}) {
  return request('/api/admin/good/export', {
    method: 'POST',
    data: params,
    responseType: 'blob',
  });
}

// 新增商品
export async function addGood(values: API.FormValues) {
  return request('/api/admin/good/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑商品
export async function editGood(values: API.FormValues) {
  return request('/api/admin/good/edit', {
    method: 'POST',
    data: values,
  });
}

// 获取分类树（用于级联选择器）
export async function getCategoryTree() {
  return request('/api/admin/goodCategory/all', {
    method: 'POST',
    data: {
      filter: {},
    },
  });
}

// 获取商户列表（用于选择器）
export async function getShopList() {
  return request('/api/admin/shop/all', {
    method: 'POST',
    data: {
      filter: { status: 1 }, // 只获取启用的商户
    },
  });
}
